module.exports = __webpack_public_path__ + "img/hyper-v.40c9f165.png";